import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdministracaoRoutingModule } from './administracao-routing.module';

@NgModule({
	imports: [CommonModule, AdministracaoRoutingModule],
})
export class AdministracaoModule {}
